module.exports = __webpack_public_path__ + "static/media/IDEA.f7141109.txt";